import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-direct-referral",
  "use": "icon-direct-referral-usage",
  "viewBox": "0 0 23 22",
  "content": "<symbol viewBox=\"0 0 23 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-direct-referral\">\n<rect x=\"1\" y=\"1\" width=\"8\" height=\"7.61905\" rx=\"2\" stroke=\"#333333\" stroke-width=\"1.5\" />\n<rect x=\"14\" y=\"13.3809\" width=\"8\" height=\"7.61905\" rx=\"2\" stroke=\"#333333\" stroke-width=\"1.5\" />\n<path d=\"M14 13.3807L8.5 8.14258\" stroke=\"#333333\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol